
import React, { useState, useEffect, useRef } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    Menu,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableSortLabel,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    TextField,
    Switch,
    FormControl,
    FormLabel,
    FormControlLabel,
    Dialog,
    DialogTitle,
    Divider,
    Slide,
    InputLabel,
    Select,
    Grid,
    Button,
    DialogActions,
    LinearProgress,
    Container,
    CircularProgress,
    Paper
} from "@mui/material";
import {ContainerClasses} from '../../../themes/containerClasses'
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import PreviewOutlinedIcon from "@mui/icons-material/PreviewOutlined";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AccountCircle from "@mui/icons-material/AccountCircle";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import PersonIcon from "@mui/icons-material/Person";
import {useTheme} from '@mui/material/styles';
import {LookupFieldModel,
        ObjectModel,
        ObjectJSON,
        ObjectFactory,
        RecordModel,
        RecordFactory,
        ActionModel,
        EmailUserModel,
        EmailConnectorModel,
        EmailConnectorFactory,
        EmailContextRecordModel,
        EmailContextObjectModel,
        EmailRecipientModel,
        EmailPreviewModel,
        EmailPreviewJSON,
        EmailPreviewFactory,
        EmailMessageModel,
        FieldMetadataModel,
        LayoutFieldFactory,
        LayoutSectionFactory,
        LayoutRelatedListModel} from '../../../models/models';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {SearchFieldComponent} from "../../../components/searchField/SearchField";
import {LayoutSectionComponent} from "../../../components/layoutSection/LayoutSection";
import {CalendarDialogComponent} from "../../../components/calendarDialog/CalendarDialog";
import {EmailFromComponent} from "../../../components/email/EmailFrom";
import { formatDate, formatDatetime } from "../../../utils/dateFunctions";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useNavigate } from "react-router";
import {setSelectedTabObject,
        getSelectedTabObject} from "../../../app/globalLayoutSlice";
import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router-dom";
import {getAppName, getObjectName, getRecordUuid } from "../../../utils/helperRouter";
import {EmailFieldComponent} from "../../fields/EmailField";
import {UrlFieldComponent} from "../../fields/UrlField";
import {UUIDFieldComponent} from "../../fields/UUIDField";
import {BigAutoFieldComponent} from "../../fields/BigAutoField";
import {AutoIdentifierNameFieldComponent} from "../../fields/AutoIdentifierNameField";
import {TextFieldComponent} from "../../fields/TextField";
import {JsonFieldComponent} from "../../fields/JsonField";
import {FileFieldComponent} from "../../fields/FileField";
import {TextFieldEncryptedComponent} from "../../fields/TextFieldEncrypted";
import {DecimalFieldComponent} from "../../fields/DecimalField";
import {BooleanFieldComponent} from "../../fields/BooleanField";
import {SelectFieldComponent} from "../../fields/SelectField";
import {DateFieldComponent} from "../../fields/DateField";
import {DateTimeFieldComponent} from "../../fields/DateTimeField";
import {LookupDialogComponent} from "../../fields/LookupDialog";
import {EmailClientComponent} from "../../email/EmailClient";
import {useSnackbar} from "notistack";

//SHIFT THIS AT SOME POINT TO OTHER ROUTINE
import { useAuth } from "../../../hooks/useAuth";
import {downloadFile as downloadFileApi} from "../../../screens/record/recordSlice";
import {getFieldError} from '../../../utils/fieldValidations';
import Config from "../../../config";

/*

COMPONENT FOR RENDERING AN EMAIL TEMPLATE

*/


export const SendEmailComponent: React.FC<{
  data: any,
  action: ActionModel
}> = ({
  data,
  action
}) => {

  const styles = ContainerClasses();

  let {appName, objectName, recordUuid} = useParams();
  const {accessToken, onInvalidToken} = useAuth();

  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const { enqueueSnackbar } = useSnackbar();


  const [availableEmailConnectors, setAvailableEmailConnectors] = useState<EmailConnectorModel[]>([]);

  const [openLookupDialog, setOpenLookupDialog] = useState<boolean>(false);

  const [emailMessages, setEmailMessages] = useState<EmailMessageModel[]>([]);


  useEffect(() => {
    const thisEmailMessage = new EmailMessageModel()
    if(data?.email_connectors){
      const thisFactory = new EmailConnectorFactory()
      const connectors = data.email_connectors.map((thisJSON: any) => thisFactory.fromJSON(thisJSON));
      setAvailableEmailConnectors(connectors);
      if(connectors.length > 0){
        thisEmailMessage.setSender(connectors[0]);
      }
    }
    if(data?.email_recipient){
      const emailRecipient = new EmailRecipientModel().fromJSON(data.email_recipient)
      thisEmailMessage.setRecipient(emailRecipient)
    }

    setEmailMessages([thisEmailMessage])

  }, [data]);

  useEffect(() => {
    if(errorMessage){
     enqueueSnackbar(errorMessage, {
          variant: "error",
       });
    setErrorMessage(null)
    }

    if(successMessage){
     enqueueSnackbar(successMessage, {
          variant: "success",
       });
    setSuccessMessage(null)
    }
  }, [errorMessage, successMessage]); // eslint-disable-line react-hooks/exhaustive-deps



   return (
     <Box>
       <EmailClientComponent
         emailConnectors = {availableEmailConnectors}
         emailMessages = {emailMessages}
       />
     </Box>
    )

};
